import { Link } from 'react-router-dom';
import usePageMeta from '@/hooks/usePageMeta';
import Breadcrumbs from '@/components/base/Breadcrumbs';
import { topics } from '@/mocks/topics';
import { incidents } from '@/mocks/incidents';

const accentStyles = [
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-800',
  'bg-secondary-100 text-secondary-800',
];

export default function Topics() {
  usePageMeta({
    title: '风险分类｜数据泄露、漏洞、盗刷与隐私风险详解 - 黑料雷达',
    description:
      '按六类风险梳理网站安全问题：数据泄露、安全漏洞、盗刷与诈骗、隐私风险、违规收集使用个人信息与监管处罚，分别说明成因、信号与应对方式。',
    keywords: '风险分类,数据泄露,安全漏洞,盗刷诈骗,隐私风险,违规收集,监管处罚',
    canonical: '/topics',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: '网站风险分类总览',
      url: 'https://worswgu.cn/topics',
      inLanguage: 'zh-CN',
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://worswgu.cn/' },
          { '@type': 'ListItem', position: 2, name: '风险分类', item: 'https://worswgu.cn/topics' },
        ],
      },
    },
  });

  return (
    <>
      <section className="border-b border-background-200 bg-background-100/70">
        <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
          <Breadcrumbs items={[{ label: '首页', to: '/' }, { label: '风险分类' }]} />
          <h1 className="mt-5 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            六类风险，对应六种应对方式
          </h1>
          <p className="mt-3 max-w-3xl text-sm leading-7 text-foreground-600">
            「网站有问题」是一句模糊的判断。真正有用的是分清它属于哪一类风险——
            是已经泄露的数据，还是尚未被利用的漏洞；是资金损失，还是隐私被悄悄收集。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <ul className="space-y-6">
          {topics.map((topic, index) => {
            const count = incidents.filter((item) => item.category === topic.slug).length;
            return (
              <li
                key={topic.slug}
                className="grid grid-cols-1 overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:grid-cols-[280px_1fr]"
              >
                <div className="h-52 w-full bg-background-200 lg:h-full">
                  <img
                    src={topic.image}
                    alt={`${topic.name} 风险类别示意图`}
                    title={`${topic.name} - 网站黑料风险分类`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="p-5 md:p-7">
                  <div className="flex items-center gap-3">
                    <span className={`flex h-10 w-10 items-center justify-center rounded-md ${accentStyles[index % accentStyles.length]}`}>
                      <i className={`${topic.icon} text-xl`}></i>
                    </span>
                    <h2 className="font-heading text-xl font-bold text-foreground-950">{topic.name}</h2>
                    <span className="rounded-full border border-background-300 px-2.5 py-1 text-[11px] text-foreground-500">
                      收录 {count} 篇
                    </span>
                  </div>
                  <p className="mt-4 text-sm leading-7 text-foreground-600">{topic.description}</p>
                  <div className="mt-5 flex flex-wrap gap-3">
                    <Link
                      to={`/topic/${topic.slug}`}
                      className="whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-700"
                    >
                      查看该分类事件
                    </Link>
                    <Link
                      to={`/incidents?q=${encodeURIComponent(topic.shortName)}`}
                      className="whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100"
                    >
                      在事件库中检索
                    </Link>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </section>
    </>
  );
}